import { http } from "@/http";

// Confirmaciones de viaje por WhatsApp (DEF-ADM-024). La ciudad viaja como
// query param, no en X-City-Id: la pantalla tiene su propio desplegable y
// permite consultar cualquier ciudad sin cambiar la activa.
export default {
  // Viajes de una fecha sin confirmación enviada, ya validados por el backend.
  pending(date, cityId) {
    const params = { date };
    if (cityId) params.city_id = cityId;
    return http.get("/api/v1/confirmations/pending", { params });
  },
  // Envía las confirmaciones de los viajes seleccionados.
  // En modo prueba todos los mensajes van a testPhone y nada se marca como confirmado.
  send(bookingIds, { testMode = false, testPhone = null } = {}) {
    return http.post("/api/v1/confirmations/send", {
      booking_ids: bookingIds,
      test_mode: testMode,
      test_phone: testPhone,
    });
  },
  // Historial de envíos.
  logs(params) {
    return http.get("/api/v1/confirmations/logs", { params });
  },
};
